module.exports = __webpack_public_path__ + "img/avatar.76b7286d.jpg";